<template>
    <div>
        <template v-if="isEmail">
            <a :href="`mailto:${itemValue.replace(/\s/g, '')}`">{{ itemValue }}</a>
        </template>
        <template v-else-if="isPhone">
            <a :href="`tel:${itemValue.replace(/\s/g, '')}`">{{ itemValue }}</a>
        </template>
        <template v-else-if="isUrl">
            <a :href="`${itemValue.replace(/\s/g, '')}`" target="_blank">{{ itemValue }}</a>
        </template>
        <template v-else>
            {{ itemValue }}
        </template>
    </div>
</template>

<script>

export default
{
    name: 'PrimitiveElement',
    mixins: [
    ],
    components: {

    },
    props: {
        item: {
            type: Object,
            require: true,
        }
    },
    data() {
        return {

        }
    },
    computed: {
        itemValue() {
            return this.item ? this.item.value : null;
        },
        itemAction() {
            return this.item ? this.item.action : null;
        },
        isEmail() {
            return this.itemAction ? this.itemAction.toLowerCase() == 'email' : false;
        },
        isPhone() {
            return this.itemAction ? this.itemAction.toLowerCase() == 'phone' : false;
        },
        isUrl() {
            return this.itemAction ? this.itemAction.toLowerCase() == 'url' : false;
        }
    },
}

</script>

<style scoped lang="scss">
</style>